// This function get the smallest currency unit and return the unit for (e.g., 100 cents to charge $1.00)
export const convertAmountToCurrency = (amount: number) => amount / 100;

export const convertAmountToSmallestCurrency = (amount: number) => {
  const fixedNumber = (amount * 100).toFixed(2);
  return parseInt(fixedNumber, 10);
};
